import { useMutation, useQueryClient } from "@tanstack/react-query";
import qcareApi from "./qcareApi";


export interface DeletePalletImage {
    reportId: string,
    palletId: string,
    keyName: string,
    keyLow: string,
    prereport?: boolean,
}

export interface DeleteBatchImage {
    reportId: string,
    keyName: string,
    keyLow: string,
}

//DELETE IMAGE
const deleteImage = async (deleteData: DeletePalletImage) => {

    const { prereport, ...imageData } = deleteData

    let revalidate = prereport ? 'prereport' : 'report'
    const { data } = await qcareApi.post(`/${revalidate}/delete-image`, imageData)
    return { data, revalidate, reportId: imageData.reportId }
}

const deleteBatchImage = async (deleteData: DeleteBatchImage) => {
    const { data } = await qcareApi.post(`/report/delete-batch-image`, deleteData)
    return data
}

//DELETE IMAGE
const deletePhotoDefect = async ({ image, reportId, prereport }: any) => {
    let revalidate = prereport ? 'prereport' : 'report'
    const { data } = await qcareApi.post(`/${revalidate}/delete-defect-image`, image)
    return { data, revalidate, reportId }
}


// ------------------------- HOOKS -------------------------


export const useDeleteImage = () => {
    const queryClient = useQueryClient()
    return useMutation(deleteImage, {
        onSuccess: async (item) => {
            await queryClient.invalidateQueries([item.revalidate, item.reportId])
        }
    })
}

export const useDeleteBatchImage = () => {
    return useMutation(deleteBatchImage)
}


export const useDeletePhoto = () => {
    const queryClient = useQueryClient()
    return useMutation(deletePhotoDefect, {
        onSuccess: async (item) => {
            await queryClient.invalidateQueries([item.revalidate, item.reportId])
        }
    })
}


